import { render, staticRenderFns } from "./GenerateUnpaidLeaveLog.vue?vue&type=template&id=2e4eb9e6"
import script from "./GenerateUnpaidLeaveLog.vue?vue&type=script&lang=js"
export * from "./GenerateUnpaidLeaveLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports